module.exports = "import * as postcss from 'postcss';\r\n\r\nexport default postcss.plugin('postcss-reverse-props', (options = {}) => {\r\n    // Work with options here\r\n    return css => {\r\n        // Transform CSS AST here\r\n        css.walkRules(rule => {\r\n            // Transform each rule here\r\n            rule.walkDecls(decl => {\r\n                // Transform each property declaration here\r\n                decl.prop = decl.prop.split('').reverse().join('');\r\n            });\r\n        });\r\n    };\r\n});\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/css/transformers/postcss/codeExample.txt
 ** module id = ./src/parsers/css/transformers/postcss/codeExample.txt
 ** module chunks = 0
 **/